import createMutationsSharer from "vuex-shared-mutations"

import { AUTH_LOGOUT } from "@/store/modules/auth/mutationTypes"
// import {
//   DELIVERY_POLICIES_SUCCESS,
//   DELIVERY_POLICIES_FAILURE,
//   DELIVERY_POLICIES_REQUEST
// } from '@/modules/delivery/_store/mutationTypes'
// import {
//   GET_RETURNS_SUCCESS,
//   GET_RETURNS_FAILURE,
//   GET_RETURNS_REQUEST
// } from '@/modules/returns/_store/mutationTypes'
// import {
//   GET_TICKETS_SUCCESS,
//   GET_TICKETS_FAILURE,
//   GET_TICKETS_REQUEST,
//   REPLACE_SUPPORT_TICKET
// } from '@/modules/support/_store/mutationTypes'
import {
  DECREMENT_SUPPORT_TICKETS_COUNT,
  SET_SUPPORT_TICKETS_COUNT
} from "@/store/modules/notifications/mutationTypes"
import { SET_USER_DATA } from "@/store/modules/user/mutationTypes"

// import {
//   REPLACE_CONFIG,
//   ADD_CONFIG,
//   REMOVE_CONFIG,
//   REMOVE_DELIVERY
// } from '@/modules/delivery/_store/mutationTypes'

const mutationSharer = createMutationsSharer({
  predicate: (mutation, state) => {
    const predicate = [
      `auth/${AUTH_LOGOUT}`,
      `user/${SET_USER_DATA}`,
      // `delivery/${DELIVERY_POLICIES_SUCCESS}`,
      // `delivery/${DELIVERY_POLICIES_FAILURE}`,
      // `delivery/${DELIVERY_POLICIES_REQUEST}`,
      // `returns/${GET_RETURNS_SUCCESS}`,
      // `returns/${GET_RETURNS_FAILURE}`,
      // `returns/${GET_RETURNS_REQUEST}`,
      // `support/${GET_TICKETS_SUCCESS}`,
      // `support/${GET_TICKETS_FAILURE}`,
      // `support/${GET_TICKETS_REQUEST}`,
      // `support/${REPLACE_SUPPORT_TICKET}`,
      `notifications/${SET_SUPPORT_TICKETS_COUNT}`,
      `notifications/${DECREMENT_SUPPORT_TICKETS_COUNT}`,
      // `delivery/${REPLACE_CONFIG}`,
      // `delivery/${ADD_CONFIG}`,
      // `delivery/${REMOVE_CONFIG}`,
      // `delivery/${REMOVE_DELIVERY}`,
      "messenger/SET_TOTAL_UNREAD_COUNT"
    ]

    return predicate.indexOf(mutation.type) >= 0
  }
})

export default mutationSharer
